import { dscvrIcApi } from '@/shared/api';

export const useClaimDailyStreakQuery = () => {
  return dscvrIcApi.streak.claimDailyStreak();
};
